import Swiper from 'swiper'
import { Navigation } from 'swiper/modules'

const swiperRegulars = document.querySelectorAll('.swiper-regular')

function initSwiper() {
    if (!swiperRegulars.length) return
    let breakpoints

    swiperRegulars.forEach((swiperWrapper) => {
        breakpoints = {
            0: {
                slidesPerView: 1,
                spaceBetween: 12,
            },
            640: {
                slidesPerView: 2,
                spaceBetween: 16,
            },
            1024: {
                slidesPerView: 2,
                spaceBetween: 24,
            },
            1280: {
                slidesPerView: 3,
                spaceBetween: 32,
            },
            1536: {
                slidesPerView: 3,
                spaceBetween: 48,
            },
        }

        const swiper = new Swiper(swiperWrapper, {
            modules: [Navigation],
            direction: 'horizontal',
            grabCursor: true,
            speed: 500,
            loop: false,
            draggable: true,
            navigation: {
                nextEl: swiperWrapper.querySelector('.swiper-button-next'),
                prevEl: swiperWrapper.querySelector('.swiper-button-prev'),
            },
            breakpoints: breakpoints,
        })

        function updateNavigationButtons() {
            const prevButton = swiperWrapper.querySelector('.swiper-button-prev')
            const nextButton = swiperWrapper.querySelector('.swiper-button-next')

            if (swiper.isBeginning) {
                prevButton.classList.add('disabled', 'opacity-50', 'pointer-events-none')
            } else {
                prevButton.classList.remove('disabled', 'opacity-50', 'pointer-events-none')
            }

            if (swiper.isEnd) {
                nextButton.classList.add('disabled', 'opacity-50', 'pointer-events-none')
            } else {
                nextButton.classList.remove('disabled', 'opacity-50', 'pointer-events-none')
            }
        }

        updateNavigationButtons()

        // Lyssna på händelser för att uppdatera knapparnas tillstånd
        swiper.on('reachBeginning', updateNavigationButtons)
        swiper.on('reachEnd', updateNavigationButtons)
        swiper.on('slideChange', updateNavigationButtons) // För säkerhets skull
    })
}

document.addEventListener('DOMContentLoaded', function () {
    initSwiper()
})
